import { Icon, IconNames } from '@triumph/design-system';
import { useAppContext } from '@/app/components/providers/AppContextProvider';
import {
  SectionHeadingRow,
  SectionHeadingText,
} from '../CommunicationPreferences.StyledComponents';

interface SectionHeadingProps {
  icon: IconNames;
  iconId: string;
  label: string;
}

export const SectionHeading: React.FC<SectionHeadingProps> = ({
  icon,
  iconId,
  label,
}) => {
  const { theme } = useAppContext();

  return (
    <SectionHeadingRow>
      <Icon
        name={icon}
        id={iconId}
        size="sm"
        color={theme.colors.greyscale.gray40}
      />
      <SectionHeadingText>{label}</SectionHeadingText>
    </SectionHeadingRow>
  );
};
